import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Img from 'gatsby-image'

import Layout from '../components/layouts/mainLayout'
import Banner from '../components/banner'
import ImgPara from '../components/layouts/img-para'
import Paragraph from '../components/layouts/para'

import FocusPoint from '../components/focus-point'
import Head from '../components/head'

const CoachingStaff = () => {

    const data = useStaticQuery(graphql`
        query {
            contentfulCoachingStaff {
                coachesIntro {
                  json
                }
                headCoach21u {
                    json
                }
                headCoach18u {
                    json
                }
                headCoach15u {
                    json
                }
                headCoach13u {
                    json
                }
                headCoach11u {
                    json
                }
            }
            BannerImg: file(relativePath: {eq:"coaches.jpg"}){
                ...FluidImageFragment
            }
            TwentyOneCoachImg: file(relativePath: {eq:"neil.jpg"}){
                ...FluidImageFragment
            }
            EighteenCoachImg: file(relativePath: {eq:"seanImg.jpg"}){
                ...FluidImageFragment
            }
            FifteenCoachImg: file(relativePath: {eq:"brad.jpg"}){
                ...FluidImageFragment
            }
            ThirteenCoachImg: file(relativePath: {eq:"GregWolfe.jpg"}){
                ...FluidImageFragment
            }
            ElevenCoachImg: file(relativePath: {eq:"jeff.jpg"}){
                ...FluidImageFragment
            }
        }
    `)

    return (
        <Layout>
            <Head title="Coaching Staff"/>
            <Banner 
                title="COACHES" 
                img={data.BannerImg.childImageSharp.fluid}
                height="small"
            />
            <FocusPoint
                title="Our Coaches"
                subtitle="Over 100 years of experience"
            />
            <Paragraph>
                {documentToReactComponents(data.contentfulCoachingStaff.coachesIntro.json)}
            </Paragraph>
            <div className="container">
                <ImgPara>
                    <div className="img-container span3 smallImage">
                        <Img className="img" fluid={data.EighteenCoachImg.childImageSharp.fluid} alt="" />
                    </div>
                    <div className="info span3">
                        {documentToReactComponents(data.contentfulCoachingStaff.headCoach18u.json)}
                    </div>
                </ImgPara>
                <ImgPara shaded="shaded">
                    <div className="img-container span3 smallImage">
                        <Img className="img" fluid={data.ThirteenCoachImg.childImageSharp.fluid} alt="" />
                    </div>
                    <div className="info span3">
                        {documentToReactComponents(data.contentfulCoachingStaff.headCoach13u.json)}
                    </div>
                </ImgPara>
                <ImgPara>
                    <div className="img-container span3 smallImage">
                        <Img className="img" fluid={data.TwentyOneCoachImg.childImageSharp.fluid} alt="" />
                    </div>
                    <div className="info span3">
                        {documentToReactComponents(data.contentfulCoachingStaff.headCoach21u.json)}
                    </div>      
                </ImgPara>
                <ImgPara shaded="shaded">
                    <div className="img-container span3 smallImage">
                        <Img className="img" fluid={data.FifteenCoachImg.childImageSharp.fluid} alt="" />
                    </div>
                    <div className="info span3">
                        {documentToReactComponents(data.contentfulCoachingStaff.headCoach15u.json)}
                    </div>
                </ImgPara>
                <ImgPara>
                    <div className="img-container span3 smallImage">
                        <Img className="img" fluid={data.ElevenCoachImg.childImageSharp.fluid} alt="" />
                    </div>
                    <div className="info span3">
                        {documentToReactComponents(data.contentfulCoachingStaff.headCoach11u.json)}
                    </div>
                </ImgPara>
            </div>
            
        </Layout>
    )
}

export default CoachingStaff
